<template>
    <Background>
        <a-input-search
            v-model="searchContent"
            size="large"
            placeholder="搜索订单号或微信账单中的商户单号"
            class="search"
            @search="doSearch"
            @change="onChange"
        />

        <a-radio-group
            class="search-type"
            @change="typeChange"
            v-model="type">
            <a-radio-button value="orderId">搜索订单号</a-radio-button>
            <a-radio-button value="reqId">搜索开门请求</a-radio-button>
            <a-radio-button value="wxOrderId">搜索微信商户单号</a-radio-button>
        </a-radio-group>

        <div
            v-if="foundOrder"
            class="order-detail">
            <div class="order-left-area">
                <a-icon
                    class="order-icon"
                    type="credit-card" />

                <a-button
                    v-on:click="watchShell"
                    size="small"
                    class="watch-shell-button">
                    查看主控日志
                </a-button>

                <div class="order-info-line">
                    <div class="order-info-label">
                        订单号
                    </div>
                    <div class="order-info-content">
                        {{ orderId }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        下单时间
                    </div>
                    <div class="order-info-content">
                        {{ orderCreatedAt }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        开门时间
                    </div>
                    <div class="order-info-content">
                        {{ orderOpenDoorAt }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        消费者电话
                    </div>
                    <div class="order-info-content">
                        {{ consumerPhone }}
                    </div>
                </div>

                <div class="order-info-splitline"/>

                <div class="order-info-line">
                    <div class="order-info-label">
                        货柜编号
                    </div>
                    <div class="order-info-content">
                        {{ machineNumber }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        货柜详细地址
                    </div>
                    <div class="order-info-content">
                        {{ machineAddress }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        主控编号
                    </div>
                    <div class="order-info-content">
                        {{ boxSerialNum }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        开门请求编号
                    </div>
                    <div class="order-info-content order-require-id-line">
                        <div
                            class="open-door-request-id"
                            v-for="request in boxRequests"
                            :key="request">
                            {{ request }}
                        </div>
                    </div>
                </div>

                <div class="order-info-splitline"/>

                <div class="order-info-line">
                    <div class="order-info-label">
                        老板
                    </div>
                    <div class="order-info-content">
                        {{ bossName }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        老板电话
                    </div>
                    <div class="order-info-content">
                        {{ bossPhone }}
                    </div>
                </div>

                <div class="order-info-line">
                    <div class="order-info-label">
                        商户简称
                    </div>
                    <div class="order-info-content">
                        {{ shopName }}
                    </div>
                </div>
            </div>

            <div class="order-right-area">
                <div class="order-status-title">
                    订单状态:
                </div>
                <div class="order-status-text">
                    {{ orderStatus }} <div class="order-status-id">(状态码 {{ orderStatusId }})</div>
                </div>
                <div class="order-status-help">
                    {{ orderStatusHelp }}
                </div>

                <div class="order-video-title">
                    购物视频:
                </div>
                <div class="video-id">
                    {{ videoId }}
                </div>
                <div
                    v-if="videoUrl != ''"
                    class="video-area">
                    <div class="video-container">
                        <video
                            ref="player"
                            preload="auto"
                            controls
                            :src="videoUrl"/>
                    </div>
                </div>
                <div
                    class="order-no-video"
                    v-else>
                    {{ videoDesc }}
                </div>
            </div>
        </div>
        <div
            v-else
            class="order-detail">
            <div
                class="search-note"
                v-if="searchOrder">
                没有搜索到和 {{ searchContent }} 相关的订单
            </div>
            <div
                class="search-note"
                v-else>
                <div v-if="type == 'orderId'">
                    请搜索订单号
                </div>
                <div v-else-if="type == 'reqId'">
                    请搜索开门请求
                </div>
                <div v-else>
                    请搜索微信商户订单号
                </div>
            </div>
        </div>
    </Background>
</template>

<script>
 import Background from "./Background.vue"

 import { parseDate } from "../util/date.js"
 import message from "ant-design-vue/lib/message";

 const orderStatusDescription = {
     "0" : {
         status: "订单取消后关闭",
         help: "消费者创建订单后，但是并没有对订单进行实际支付，在待取货列表中点击‘删除订单’按钮后就会进入这种状态，消费者删除订单后，订单自动会从待取货列表中消失，这种订单不用关注，不会对系统产生任何影响",
         videoDesc: "订单取消这种状态，没有产生消费，所以没有视频"
     },
     "1" : {
         status: "订单创建，但没有支付",
         help: "消费者只是创建了订单，但是并没有对订单进行实际支付（这种订单一般是因为消费者实际支付时账户没钱产生的），消费者在‘待取货’列表中手动支付后可以继续取货，也可以在‘待取货’列表中直接退款，这种退款一般都是实时退款",
         videoDesc: "订单未支付，无法开门，所以没有视频"
     },
     "2" : {
         status: "订单正在支付中",
         help: "消费者点击支付按钮后，订单会马上进入支付中状态，这种状态的持续时间取决于微信支付服务器的响应时间，一般在几秒内完成，这种状态属于消费者小程序的瞬间状态，不用关注",
         videoDesc: "订单支付中未完成，无法开门，所以没有视频"
     },
     "3" : {
         status: "订单支付失败",
         help: "消费者点击支付按钮后，如果消费者账户里面没钱, 支付会失败，这个只是临时状态，消费者小程序端会马上变成 ’订单创建，单没有支付’的状态，支付失败的订单消费者可以选择继续手动支付或者删除订单",
         videoDesc: "订单支付失败，无法开门，所以没有视频"
     },
     "4" : {
         status: "订单支付成功",
         help: "消费者点击支付按钮后，一旦支付成功后，消费者可以选择立即取货，也可以先把订单放到‘待取货’列表中，稍后扫码取货",
         videoDesc: "订单支付成功，但消费者还没有开门取货, 所以没有视频"
     },
     "10" : {
         status: "订单退款中",
         help: "消费者支付订单后，只要不开门，可以在‘待取货’列表中点击‘退款’按钮发起退款，退款的时间取决于微信，微信一般在10秒内发起实时退款",
         videoDesc: "订单支付后点击退款按钮，消费者在支付后还没有开门取货, 所以没有视频"
     },
     "11" : {
         status: "订单退款失败",
         help: "商家账户余额不足时会导致退款失败，消费者小程序在退款失败的状态下也显示‘退款中’的字样避免消费者焦虑，退款失败一般是因为商户账户余额不足导致的，这种情况下应该尽快联系商家对账户进行充值后，在B端小程序点击 ‘确认充值’ 按钮，系统会自动发起退款操作退款给消费者。",
         videoDesc: "订单支付后点击退款按钮后退款失败，消费者还没有开门取货, 所以没有视频"
     },
     "12" : {
         status: "订单退款成功",
         help: "消费者在取货之前发起的退款操作成功，退款成功的订单不可以扫码开门取货。",
         videoDesc: "订单支付后点击退款按钮后退款成功，已退款订单并没有开门取货, 所以没有视频"
     },
     "20" : {
         status: "锁已经打开",
         help: "消费者扫码取货以后，锁打开，但是消费者还没有拉开门，消费者如果不开门，锁会在6秒后自动落下，没有开门的订单依然可以继续开门或者发起退款操作, 如果一直是开锁状态，很有可能是锁硬件无法下锁或者主控系统有问题",
         videoDesc: "已经开锁，但门没有被拉开, 所以没有视频"
     },
     "22" : {
         status: "已开门",
         help: "消费者扫码取货，门被消费者拉开，门开了3分钟以后会自动报警，门打开超过5分钟没关闭，系统会自动推送超长订单给商户，这种情况需要商户检查是门坏了还是恶意卡门的行为",
         videoDesc: "门打开，还没有关门，视频正常上传中"
     },
     "23" : {
         status: "已关闭",
         help: "消费者扫码取货，门开了以后关闭，主控会自动上传购物视频到识别系统，一般会在15秒上传完，如果长时间没法上传有可能是网络问题、主控问题或者摄像头松动的问题",
         videoDesc: "门已经关闭，视频最快会在关门后15秒内上传完视频，请稍后再查询"
     },
     "30" : {
         status: "订单识别中",
         help: "订单购物视频分配给识别系统后进入识别中的状态，只有识别后才知道订单的实际消费情况, 注意一个视频一直没有结果，很有可能是长视频，需要用长识别系统账户登录识别系统查看",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "31" : {
         status: "订单识别完成",
         help: "识别系统确认消费者消费物品和购物清单一致，不需要额外扣款或退款，识别完结后，系统不会再就订单进行任何额外扣款和退款操作，如果识别有误，请让商户用红包来解决",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "32" : {
         status: "识别系统发起的额外扣款",
         help: "识别系统发现消费者需要额外支付时，会自动发起额外扣款操作，这个状态的时间取决于微信，一般在10秒内微信会有结果反馈",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "33" : {
         status: "识别系统发起的额外扣款失败",
         help: "识别系统发现消费者需要额外支付时，会自动发起额外扣款操作，当消费者免密次数用完、消费者账户没钱或者消费者取消免密签约都会导致扣款失败，系统会针对未支付的问题，在随后的每一天中午12:00左右自动扣款，直到扣款成功。当有未支付发生时，消费者无法在任何货柜中购物，除非手动支付结清欠款。这种情况建议商户联系消费者解决未支付问题。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "34" : {
         status: "识别系统发起的额外扣款成功",
         help: "识别系统发现消费者需要额外支付时，会自动发起额外扣款操作并成功扣款，消费者会在微信看到额外扣款的账单。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "35" : {
         status: "识别系统发起的退款中",
         help: "识别系统确定需要退款给消费者时，发起退款操作，这个状态的时间取决于微信，一般在10秒内微信会有结果反馈",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "36" : {
         status: "识别系统发起的退款失败",
         help: "识别系统确定需要退款给消费者后退款失败，退款失败一般是因为商户账户余额不足导致的，这种情况下应该尽快联系商家对账户进行充值后，在B端小程序点击 ‘确认充值’ 按钮，系统会自动发起退款操作退款给消费者。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "37" : {
         status: "识别系统发起的退款成功",
         help: "识别系统确定需要退款给消费者，并成功退款到消费者账户中，如果订单还有纠纷，请让商家用微信红包解决",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "50" : {
         status: "异常订单处理中",
         help: "识别系统推送异常订单给商户后，商户还没有及时处理，会导致消费者订单无法进行核算，应尽快联系商户处理异常订单",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "51" : {
         status: "商家判定异常订单不需要退款或扣款",
         help: "识别系统推送异常订单给商户后，商户最后的裁决决定不需要进行额外扣款或退款操作",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "52" : {
         status: "异常订单发起的额外扣款",
         help: "商家决定消费者需要额外支付时，会自动发起额外扣款操作，这个状态的时间取决于微信，一般在10秒内微信会有结果反馈",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "53" : {
         status: "商家发起的异常订单额外扣款失败",
         help: "商家决定消费者需要额外支付时，会自动发起额外扣款操作，当消费者免密次数用完、消费者账户没钱或者消费者取消免密签约都会导致扣款失败，系统会针对未支付的问题，在随后的每一天中午12:00左右自动扣款，直到扣款成功。当有未支付发生时，消费者无法在任何货柜中购物，除非手动支付结清欠款。这种情况建议商户联系消费者解决未支付问题。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "54" : {
         status: "商家发起的异常订单额外扣款成功",
         help: "商家决定消费者需要额外支付时，会自动发起额外扣款操作并成功扣款，消费者会在微信看到额外扣款的账单。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "55" : {
         status: "商家发起的异常订单退款中",
         help: "商家确定需要退款给消费者时，发起退款操作，这个状态的时间取决于微信，一般在10秒内微信会有结果反馈",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "56" : {
         status: "商家发起的异常订单退款失败",
         help: "商家确定需要退款给消费者后退款失败，退款失败一般是因为商户账户余额不足导致的，这种情况下应该尽快联系商家对账户进行充值后，在B端小程序点击 ‘确认充值’ 按钮，系统会自动发起退款操作退款给消费者。",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
     "57" : {
         status: "商家发起的异常订单退款成功",
         help: "商家确定需要退款给消费者，并成功退款到消费者账户中，如果订单还有纠纷，请让商家用微信红包解决",
         videoDesc: "视频已经上传完毕，如果看不到视频就是异常，请联系研发人员"
     },
 }

 export default {
     name: 'OrderTracking',
     data() {
         return {
             searchContent: "",
             type: "orderId",
             orderId: "",
             orderStatusId: "",
             orderStatus: "",
             orderStatusHelp: "",
             consumerPhone: "",
             machineNumber: "",
             machineAddress: "",
             boxSerialNum: "",
             boxRequests: [],
             bossName: "",
             bossPhone: "",
             shopName: "",
             orderCreatedAt: "",
             orderOpenDoorAt: "",
             foundOrder: false,
             searchOrder: false,
             videoUrl: "",
             videoId: "",
             videoDesc: "",
         }
     },
     components: {
         Background,
     },
     computed: {
     },
     mounted() {
         if (sessionStorage.getItem("orderSearch") != "") {
             var orderId = sessionStorage.getItem("orderSearch")
             this.searchContent = orderId
             this.doSearch()

             sessionStorage.setItem("orderSearch", "")
         }
     },
     methods: {
         watchShell() {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-status/${this.machineNumber}`;
             var accessToken = localStorage.getItem('accessToken')

             var that = this
             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response.online) {
                     var data = {
                         "action": "debug",
                     }
                     fetch(url, {
                         method: 'PUT',
                         body: JSON.stringify(data),
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log("Error: ", error)
                     }).then(response => {
                         if (response && response.url) {
                             window.open(response.url)
                         } else {
                             message.destroy()
                             message.error("找不到主控日志授权码")
                         }
                     })
                 } else {
                     message.error("主控不在线，无法查看日志，请刷新重试")
                 }
             })
         },
         onChange() {
             this.searchOrder = false
         },
         doSearch() {
             if (this.searchContent != "") {
                 var that = this

                 var accessToken = localStorage.getItem('accessToken')
                 if (this.type == "orderId") {
                     const url = `${process.env.VUE_APP_API_SERVER}/search-order?orderId=${this.searchContent}`;

                     fetch(url, {
                         method: 'GET',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log(error)
                         that.foundOrder = false
                     }).then(response => {
                         console.log(response)
                         that.handleSearchResult(response)
                     })
                 } else if (this.type == "reqId") {
                     const url = `${process.env.VUE_APP_API_SERVER}/search-order?reqId=${this.searchContent}`;

                     fetch(url, {
                         method: 'GET',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log(error)
                         that.foundOrder = false
                     }).then(response => {
                         console.log(response)
                         that.handleSearchResult(response)
                     })
                 } else if (this.type == "wxOrderId") {
                     const url = `${process.env.VUE_APP_API_SERVER}/search-order?paymentId=${this.searchContent}`;

                     fetch(url, {
                         method: 'GET',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log(error)
                         that.foundOrder = false
                     }).then(response => {
                         console.log(response)
                         that.handleSearchResult(response)
                     })
                 }
             }
         },
         typeChange (e) {
             this.type = e.target.value
         },
         handleSearchResult(response) {
             console.log("###### ", response)

             if (response.error) {
                 this.foundOrder = false
             } else {
                 this.searchOrder = true
                 this.foundOrder = true

                 this.orderId = response.ConsumerOrder.OrderId
                 this.orderStatusId = response.ConsumerOrder.Status
                 this.consumerPhone = response.ConsumerInfo.Phone
                 this.bossName = response.BossInfo.Username
                 this.bossPhone = response.BossInfo.Phone
                 this.shopName = response.ShopInfo.ShopName
                 this.orderCreatedAt = parseDate(response.ConsumerOrder.CreatedAt)

                 this.orderStatus = orderStatusDescription[this.orderStatusId]["status"]
                 this.orderStatusHelp = orderStatusDescription[this.orderStatusId]["help"]

                 this.videoUrl = response.VideoUrl
                 if (response.MarkerOrder && response.MarkerOrder.VideoId) {
                     this.videoId = response.MarkerOrder.VideoId
                 } else {
                     this.videoId = ""
                 }
                 this.videoDesc = orderStatusDescription[this.orderStatusId]["videoDesc"]

                 this.boxRequests = response.BoxRequests.map((e) => {
                     return e.ReqId
                 })

                 if (response.BoxRequests.length > 0) {
                     this.orderOpenDoorAt = parseDate(response.BoxRequests[response.BoxRequests.length - 1].CreatedAt)
                 } else {
                     this.orderOpenDoorAt = "还未开门"
                 }

                 if (response.MachineInfo === null) {
                     this.machineNumber = "货柜已删除，未知编号"
                     this.machineAddress = "货柜已删除，未知地址"
                     this.boxSerialNum = "货柜已删除，未知主控编号"
                 } else {
                     this.machineNumber = response.MachineInfo.MachineSerialNum
                     this.machineAddress = response.MachineInfo.Address + response.MachineInfo.AddressDetail
                     this.boxSerialNum = response.MachineInfo.BoxSerialNum
                 }
             }
         }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .order-detail {
     padding: 30px;
     background-color: #FFF;
     border-radius: 5px;
     min-height: 500px;
     width: 900px;
     margin-top: 20px;

     display: flex;
     flex-direction: row;
 }

 .order-left-area {
     margin-right: 20px;
     padding-right: 30px;
     border-right: 1px solid #EFEFEF;

     display: flex;
     flex-direction: column;
     justify-content: center;

     flex: 1;
 }

 .order-right-area {
     width: 450px;
 }

 .order-info-line {
     text-align: start;
     font-size: 14px;

     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .order-info-splitline {
     height: 20px;
 }

 .order-info-label {
     width: 120px;
     color: #666;
 }

 .order-info-content {
     color: #666;
     user-select: all;
 }

 .order-note-title {
     text-align: start;
     font-size: 18px;
     color: #000;
 }

 .order-node-line {
     margin-top: 15px;

     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .order-node-label {
     width: 150px;
     color: #999;
 }

 .order-node-content {
     color: #333;
 }

 .order-icon {
     font-size: 120px;
     color: #666;
 }

 .search-type {
     margin-top: 20px;
 }

 .search-note {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     width: 100%;
     font-size: 30px;
     color: #999;
 }

 .order-status-title {
     text-align: start;
     font-size: 18px;
     color: #000;
 }

 .order-status-text {
     text-align: start;
     font-size: 16px;
     color: #333;
     margin-top: 10px;

     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .order-status-id {
     text-align: start;
     font-size: 14px;
     color: #666;
     margin-left: 10px;
 }

 .order-status-help {
     text-align: start;
     font-size: 14px;
     margin-top: 10px;
     color: #333;
     background-color: #FFE47D;
     padding: 10px;
     border-radius: 5px;
 }

 .order-video-title {
     text-align: start;
     font-size: 18px;
     color: #000;
     margin-top: 20px;
 }

 .video-area {
     position: relative;
     margin-top: 10px;
 }

 .video-container {
     background: #000;
     width: 100%;
     height: 100%;
     font-size: 0;
     text-align: center;
 }

 .video-container:before {
     content: "";
     width: 1px;
     height: 100%;
     display: inline-block;
     vertical-align: middle;
     margin-left: -1px;
 }

 .video-container video {
     max-width: 100%;
     max-height: 100%;
     display: inline-block;
     vertical-align: middle;
 }

 .order-no-video {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     height: 300px;
     width: 100%;
     font-size: 18px;
     padding-left: 20px;
     padding-right: 20px;
     color: #999;
 }

 .open-door-request-id {
     margin-right: 5px;
 }

 .video-id {
     color: #666;
     font-size: 14px;
     user-select: all;
     margin-top: 5px;
 }

 .watch-shell-button {
     width: 100px;
     margin-bottom: 20px;
     align-self: center;
 }

 .order-require-id-line {
     display: flex;
     user-select: text;
     width: 200px;
     flex-wrap: wrap;
     margin-top: 5px;
 }
</style>
